/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkbookItemType } from './WorkbookItemType';
import {
    WorkbookItemTypeFromJSON,
    WorkbookItemTypeFromJSONTyped,
    WorkbookItemTypeToJSON,
    WorkbookItemTypeToJSONTyped,
} from './WorkbookItemType';

/**
 * 
 * @export
 * @interface AddWorkbookItemRequestDto
 */
export interface AddWorkbookItemRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AddWorkbookItemRequestDto
     */
    workbookId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddWorkbookItemRequestDto
     */
    title?: string | null;
    /**
     * 
     * @type {WorkbookItemType}
     * @memberof AddWorkbookItemRequestDto
     */
    itemType?: WorkbookItemType;
    /**
     * 
     * @type {boolean}
     * @memberof AddWorkbookItemRequestDto
     */
    isLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddWorkbookItemRequestDto
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddWorkbookItemRequestDto
     */
    stateJson?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddWorkbookItemRequestDto
     */
    snapshotJson?: string | null;
}



/**
 * Check if a given object implements the AddWorkbookItemRequestDto interface.
 */
export function instanceOfAddWorkbookItemRequestDto(value: object): value is AddWorkbookItemRequestDto {
    return true;
}

export function AddWorkbookItemRequestDtoFromJSON(json: any): AddWorkbookItemRequestDto {
    return AddWorkbookItemRequestDtoFromJSONTyped(json, false);
}

export function AddWorkbookItemRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddWorkbookItemRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workbookId': json['workbookId'] == null ? undefined : json['workbookId'],
        'title': json['title'] == null ? undefined : json['title'],
        'itemType': json['itemType'] == null ? undefined : WorkbookItemTypeFromJSON(json['itemType']),
        'isLocked': json['isLocked'] == null ? undefined : json['isLocked'],
        'version': json['version'] == null ? undefined : json['version'],
        'stateJson': json['stateJson'] == null ? undefined : json['stateJson'],
        'snapshotJson': json['snapshotJson'] == null ? undefined : json['snapshotJson'],
    };
}

export function AddWorkbookItemRequestDtoToJSON(json: any): AddWorkbookItemRequestDto {
    return AddWorkbookItemRequestDtoToJSONTyped(json, false);
}

export function AddWorkbookItemRequestDtoToJSONTyped(value?: AddWorkbookItemRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workbookId': value['workbookId'],
        'title': value['title'],
        'itemType': WorkbookItemTypeToJSON(value['itemType']),
        'isLocked': value['isLocked'],
        'version': value['version'],
        'stateJson': value['stateJson'],
        'snapshotJson': value['snapshotJson'],
    };
}

